export default __webpack_public_path__ + "static/media/ANEXO-II-CONVENIO-CAIXAxOAB-Declaracao-do-advogado-beneficiario-advogado.6387333d.doc";